import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { GlobalService } from '@commoncore/services/global.service';

@Injectable({
  providedIn: 'root'
})
class TeamFolderService {
  universalService:any;
  router: any;
  localStorageService: any;
  searchService: any;
  constructor(public globalService:GlobalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.router = globalService.getRouterRef();
    this.localStorageService = globalService.getLocalStorageSvcRef();
    this.searchService = globalService.getSearchServiceRef();
  } 


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> | boolean {
      return this.checkAccessRightsForActivatingTeamFolder();
  }


  checkAccessRightsForActivatingTeamFolder(){ // this is to restrict not ent user from accessing teams folders
    var userData = this.localStorageService.getUserData(true);
    var nativeHeaders = this.localStorageService.getNativeHeaders('nativeHeaders');
    this.searchService.openAutoSearch.next(false);
    if(userData && userData["jcEntInfo"]){
      return true
    }else if(window.location.href.includes('webview') || this.universalService.inAppWebViewOpened || nativeHeaders){
      return true;
    }
    this.router.navigate(["/home"]);
    return false;
    

  }
  
}

export const TeamFolderGuard: CanActivateFn =
    (route, state) => {
      return inject(TeamFolderService).canActivate(route,state);
    }
